module.exports = __webpack_public_path__ + "static/media/proj3.ed7b77cf.png";